import { Row, RowList } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';

const ModalTestInterpretation: React.FC = () => {
    const { t } = useTranslation();

    const { trackingScreenView } = new TrackingEvents();
    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div className='modalTestInterpretation-page'>
            <div className='modalTestInterpretation-page__content'>
                <RowList>
                    <Row title={t('uploadSpeedFiber')} description={t('speedRiseInterpretTestDescription')}></Row>
                    <Row title={t('descentSpeedFiber')} description={t('loweredSpeedInterpretTest')}></Row>
                    <Row title={t('ipInterpretTestTitle')} description={t('ipInterpretTestDescription')}></Row>
                    <Row title={t('pingInterpretTestTitle')} description={t('pingInterpretTestDescription')}></Row>
                    <Row title={t('jitterInterpretTestTitle')} description={t('jitterInterpretTestDescription')}></Row>
                    <Row
                        title={t('browserInterpretTestTitle')}
                        description={t('browserInterpretTestDescription')}
                    ></Row>
                </RowList>
            </div>
        </div>
    );
};

export default ModalTestInterpretation;
